import { HttpClient } from '@angular/common/http';
import { endpoints } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { Payment } from '../models/payment';
import { Observable } from 'rxjs/Observable';
import { Auth } from '../../../autentication/Auth';
import { map } from 'rxjs/operators/map';
import * as moment from 'moment';
import { Limit, LimiteGeralModel, LimitePrazoCompensacao, LimiteTipoPeriodo } from '../../limits/models/limits';
import { FormatPricePipe } from '../../../shared/format-price.pipe';
import { BaseResult } from '../../../shared/models/base.result.model';
import { AccountNumberPipe } from '../../../shared/account-number.pipe';
import { Util } from '../../../utils/util';

@Injectable()
export class PaymentSecuritiesService {

	public scheduleSpan: boolean;

	constructor(private http: HttpClient) { }

	limits: Array<Limit>;

	getDataLimits(): Observable<any[]> {
		return this.http.get<BaseResult<LimiteGeralModel[]>>(`${endpoints.limits.getLimits}?tipoLimite=TODOS`).pipe(
			map((data: BaseResult<LimiteGeralModel[]>) => {
				if (data.Sucesso) {
					this.limits = data.Retorno.map(item => {
						if (item.Tipo === LimiteTipoPeriodo.BOLETO_DIURNO || item.Tipo === LimiteTipoPeriodo.BOLETO_NOTURNO) {
							const limit = new Limit();
							const FP = new FormatPricePipe();

							limit.typeLimit = item.Tipo;

							if (item.ValorMaximoPorTransacao) {
								limit.singleMaxValue = FP.transform(item.ValorMaximoPorTransacao, false);
							} else {
								limit.singleMaxValue = 'Ilimitado';
							}

							if (item.ValorMaximoPorDia) {
								limit.dailyMaxValue = FP.transform(item.ValorMaximoPorDia, false);
							} else {
								limit.dailyMaxValue = 'Ilimitado';
							}

							limit.timeLimit = item.FaixaHorario.HorarioInicial + 'h' + ' - ' + item.FaixaHorario.HorarioFinal + 'h';

							// limit.fee = FP.transform(item.Tarifa, false); // aqui tarifa

							if (item.FaixaHorario.PrazoCompensacao === LimitePrazoCompensacao.MESMO_DIA_UTIL) {
								limit.compensationDate = 'Mesmo dia*';
							} else if (item.FaixaHorario.PrazoCompensacao === LimitePrazoCompensacao.PROXIMO_DIA_UTIL) {
								limit.compensationDate = 'Próximo dia útil*';
							} else {
								limit.compensationDate = item.FaixaHorario.PrazoCompensacao + ' dias úteis';
							}

							return limit;
						}
					});

				}

				return this.limits;
			}));
	}

	getLimitsV2(): Observable<BaseResult<LimiteGeralModel[]>> {
		return this.http.get<BaseResult<LimiteGeralModel[]>>(`${endpoints.limits.getLimits}?tipoLimite=TODOS`);
	}

	sendPayment(payment: Payment): Observable<any> {
		const accNumPipe = new AccountNumberPipe();

		const paymentData = {
			DataEmissao: new Date(),
			Valor: payment.value,
			CodAgenciaOrigem: Auth.getInstance().getUser().agency,
			CodContaOrigem: accNumPipe.transform(Auth.getInstance().getUser().accountNumber),
			CodBarras: payment.barCode,
			DataVencimento: moment(payment.dueDate).format('YYYY-MM-DD'),
			LinhaDigitavel: null,
			DataAgendamento: null,
			CPFSolicitante: Auth.getInstance().getUser().cpf
		};

		if (payment.barCode.length > 44) {
			paymentData.LinhaDigitavel = payment.barCode;
			paymentData.CodBarras = null;
		}

		if (payment.dateType !== 'today') {
			paymentData.DataAgendamento = moment(payment.date).format('YYYY-MM-DD');
		}

		const url = payment.codeBarCip ? endpoints.payments.ticketV2 : endpoints.payments.ticket;

		return this.http.post(url, paymentData).pipe(map((data: any) => {

			return data;

		}));

	}

	confirmPayment(paymentType: string, paymentId: number): Observable<any> {
		return this.http.post(endpoints.payments.confirm + paymentType + '/' + paymentId + endpoints.confirmation, {}).pipe(map((data: any) => {
			return data;
		}));
	}

	confirmPaymentCip(paymentType: string, paymentId: number): Observable<any> {
		const guid = Util.generateGUID();
		return this.http.post(endpoints.payments.confirmCip + paymentType + '/' + paymentId + endpoints.confirmation + '/' + guid, {}).pipe(map((data: any) => {
			return data;
		}));
	}

	consultPaymentCip(codeBar: string, date: any): Observable<any> {

		const codeBarNumber = codeBar.replace(/\D/g, '');
		let dataDigitableLine = null;
		let dataCodeBar = null;
		let dataDate = null;

		if (date === 'today') {
			dataDate = moment(new Date()).format('YYYY-MM-DD');
		} else {
			dataDate = moment(date).format('YYYY-MM-DD');
		}

		if (codeBarNumber.length > 44) {
			dataDigitableLine = codeBarNumber;
		} else {
			dataCodeBar = codeBarNumber;
		}

		const codeBarData = {
			'LinhaDigitavel': dataDigitableLine,
			//'DataAgendamento': dataDate,
			//'CodigoBarras': dataCodeBar
		};

		return this.http.post(endpoints.payments.cipQuery, codeBarData).pipe(map((data: any) => {

			const list = new Payment();
			const item = data.Retorno;
			const accNumPipe = new AccountNumberPipe();

			if (data.Sucesso) {

				if (item.NumeroIdentificacaoTitulo === '' || item.NumeroIdentificacaoTitulo === undefined) {
					list.codeBarCip = false;

					list.securitieRebateValue = item.ValorAbatimentoTitulo;
					list.taxValue = item.ValorJuros;
					list.fineValue = item.ValorMulta;
					list.chargesValue = item.ValorEncargos;
					list.discountValue = item.ValorDesconto;

					if (item.NomeBeneficiarioOriginal.length) {
						list.assignorName = item.NomeBeneficiarioOriginal;
					}
					if (item.CpfCnpjBeneficiario.length) {
						list.assignorCpfCnpj = item.CpfCnpjBeneficiario;
					}

					list.payerAgency = Auth.getInstance().getUser().agency;
					list.payerAccount = accNumPipe.transform(Auth.getInstance().getUser().accountNumber);
					list.payerName = Auth.getInstance().getUser().name ? Auth.getInstance().getUser().name : Auth.getInstance().getUser().loggedUserName;
					list.payerCpfCnpj = Auth.getInstance().getUser().cpfCnpj ? Auth.getInstance().getUser().cpfCnpj : Auth.getInstance().getUser().cpf;

				} else {
					list.codeBarCip = true;

					list.value = item.ValorTotal;
					list.nominalValue = item.ValorNominal;
					list.dueDateInput = item.DataVenctoTitulo;
					list.securitieLimitDate = item.DataLimiteTitulo;
					list.minValue = item.ValorMinimo;
					list.maxValue = item.ValorMaximo;
					list.securitieRebateValue = item.ValorAbatimentoTitulo;
					list.taxValue = item.ValorJuros;
					list.fineValue = item.ValorMulta;
					list.chargesValue = item.ValorEncargos;
					list.discountValue = item.ValorDesconto;
					list.paymentBlocked = item.PagamentoBloqueado;

					list.assignorName = item.NomeBeneficiarioOriginal;
					list.assignorCpfCnpj = item.CpfCnpjBeneficiario;

					list.payerAgency = Auth.getInstance().getUser().agency;
					list.payerAccount = accNumPipe.transform(Auth.getInstance().getUser().accountNumber);
					list.payerName = Auth.getInstance().getUser().name ? Auth.getInstance().getUser().name : Auth.getInstance().getUser().loggedUserName;
					list.payerCpfCnpj = Auth.getInstance().getUser().cpfCnpj ? Auth.getInstance().getUser().cpfCnpj : Auth.getInstance().getUser().cpf;

					if (item.PagamentoParcial) {
						if (item.TipoPagamento === 'qualquerValor') {
							list.anyValue = true;
							if (item.ValorTotal === 0) {
								list.value = item.ValorNominal;
							}
						} else if (item.TipoPagamento === 'valorMinimo') {
							list.minTypeValue = true;
						} else if (item.TipoPagamento === 'minimoAMaximo') {
							list.minMaxTypeValue = true;
							if (item.ValorTotal === 0) {
								list.value = item.ValorNominal;
							}
						} else if (item.TipoPagamento === 'valorTotal') {
							list.totalTypeValue = true;
						}
					} else {
						list.parcialPayment = true;
					}
				}
			}

			return list;
		}));
	}

	consultPaymentAgreement(codeBar: string, date: any): Observable<any> {

		const codeBarNumber = codeBar.replace(/\D/g, '');
		let dataDigitableLine = null;
		let dataCodeBar = null;
		let dataDate = null;

		if (date === 'today') {
			dataDate = moment(new Date()).format('YYYY-MM-DD');
		} else {
			dataDate = moment(date).format('YYYY-MM-DD');
		}

		if (codeBarNumber.length > 44) {
			dataDigitableLine = codeBarNumber;
		} else {
			dataCodeBar = codeBarNumber;
		}

		const codeBarData = {
			'LinhaDigitavel': dataDigitableLine,
			'DataAgendamento': dataDate,
			'CodigoBarras': dataCodeBar
		};

		return this.http.post(endpoints.payments.covenantQuery, codeBarData).pipe(map((data: any) => {

			const list = new Payment();
			const item = data.Retorno;
			const FP = new FormatPricePipe();

			if (data.Sucesso) {
				list.value = item.VlrDocumento;
				list.paymentNameAgreement = item.NmConveniada;
			}

			return list;
		}));
	}

	sendPaymentAgreement(payment: Payment): Observable<any> {

		const paymentDate = {
			Valor: payment.value,
			CodBarras: payment.barCode,
			LinhaDigitavel: null,
			DataAgendamento: null,
			NmConveniada: payment.paymentNameAgreement
		};

		if (payment.barCode.length > 44) {
			paymentDate.LinhaDigitavel = payment.barCode;
			paymentDate.CodBarras = null;
		}

		if (payment.dateType !== 'today') {
			paymentDate.DataAgendamento = moment(payment.date).format('YYYY-MM-DD');
		}

		return this.http.post(endpoints.payments.covenant, paymentDate).pipe(map((data: any) => {
			return data;
		}));

	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-securities/services/payment-securities.service.ts